// platform/app/src/hooks/usePeople.ts
import { useQuery } from '@tanstack/react-query'
import { supabase } from '@loop3/supabase-client'
import type { Person } from '@/lib/types'

export function usePeople() {
  return useQuery({
    queryKey: ['people'],
    queryFn: async (): Promise<Person[]> => {
      const { data, error } = await supabase
        .from('people')
        .select('id, name, role, sort_order')
        .order('sort_order', { ascending: true })
      if (error) throw error
      return (data ?? []) as Person[]
    },
    staleTime: 60_000,
  })
}
